import Highcharts from "highcharts";
import { useTheme } from "@mui/material";

export const useCommonHighchartsOptions = (): Highcharts.Options => {
  const theme = useTheme();

  return {
    credits: {
      enabled: false,
    },
    tooltip: {
      borderRadius: theme.shape.borderRadius,
      borderColor: "transparent",
      backgroundColor: "transparent",
      shadow: false,
      style: {
        boxShadow: "none",
        fontFamily: theme.typography.fontFamily,
        fontSize: `${theme.typography.caption.fontSize}px`,
      },
      useHTML: true,
      shape: "square",
      stickOnContact: true,
    },
    plotOptions: {
      line: {
        marker: {
          enabled: false,
        },
        lineWidth: 2,
      },
      area: {
        marker: {
          enabled: false,
        },
        lineWidth: 2,
      },
      series: {
        clip: false,
      },
    },
    xAxis: {
      labels: {
        overflow: "justify",
      },
    },
    yAxis: {
      min: -0.4,
      startOnTick: false,
    },
    chart: {
      zooming: { mouseWheel: false },
    },
  };
};
